import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ensureCsrfCookie } from "../api/csrf";
import AdminLoginForm from "../components/AdminLoginForm";
import { useAuth } from "../context/AuthContext";
import { getAppSurfaceStyles } from "../theme/siteTheme";

const AdminLoginPage: React.FC = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { isAuthenticated, login } = useAuth();
  const theme = useTheme();
  const styles = getAppSurfaceStyles(theme);

  useEffect(() => {
    ensureCsrfCookie();
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/spielplan?displayOption=spieltag");
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    const success = await login(username, password);
    if (!success) {
      setError("Ungültiger Benutzername oder Passwort.");
    }
    setLoading(false);
  };

  if (isAuthenticated) {
    return null;
  }

  return (
    <Box
      sx={{
        minHeight: "80vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "background.default",
      }}
    >
      <Paper
        elevation={4}
        sx={{
          p: 4,
          minWidth: 320,
          maxWidth: 380,
          borderRadius: 4,
          bgcolor: "rgba(255,255,255,0.92)",
          border: "1px solid rgba(31,41,55,0.08)",
          boxShadow: styles.calloutPanel.boxShadow,
        }}
      >
        <Typography variant="h4" sx={{ mb: 2, color: "text.primary", fontWeight: 700 }}>
          Admin Login...
        </Typography>
        <AdminLoginForm
          loading={loading}
          error={error}
          username={username}
          password={password}
          setUsername={setUsername}
          setPassword={setPassword}
          onSubmit={handleSubmit}
        />
      </Paper>
    </Box>
  );
};

export default AdminLoginPage;
